import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Button, Col, Collapse, Modal, Row, Select, Timeline } from "antd";
import moment from "moment";
import {
  deleteLeadNote,
  deleteLeadRemarks,
  getAllLeadNotes,
  getAllLeadRemarks,
  getLeadNoteDetails,
  getLeadRemarksDetails,
} from "../../actionCreator/leadDetailsActionCreator";
import filter from "../../assets/svg/filter.svg";
import downIcon from "../../assets/svg/angle-down-solid.svg";
import Loader from "../loader";

const options = [
  {
    label: (
      <div className="d-flex gap-10 align-items-center">
        <img src={filter} alt="" style={{ width: 16, height: 16 }} />
        Activities
      </div>
    ),
    value: null,
  },
  {
    label: (
      <div className="d-flex gap-10 align-items-center">
        <i className="las la-file-alt" />
        Notes
      </div>
    ),
    value: "notes",
  },
  {
    label: (
      <div className="d-flex gap-10 align-items-center">
        <i className="las la-phone" />
        Calls
      </div>
    ),
    value: "call",
  },
  {
    label: (
      <div className="d-flex gap-10 align-items-center">
        <i className="las la-envelope" />
        Emails
      </div>
    ),
    value: "email",
  },
  {
    label: (
      <div className="d-flex gap-10 align-items-center">
        <i className="las la-handshake" />
        Meetings
      </div>
    ),
    value: "meeting",
  },
  {
    label: (
      <div className="d-flex gap-10 align-items-center">
        <i className="las la-file-alt" />
        Follow up
      </div>
    ),
    value: "followup",
  },
  {
    label: (
      <div className="d-flex gap-10 align-items-center">
        <i className="las la-comment-dots" />
        Chats
      </div>
    ),
    value: "chat",
  },
  {
    label: (
      <div className="d-flex gap-10 align-items-center">
        <i className="lab la-whatsapp" />
        Whatsapp
      </div>
    ),
    value: "whatsapp",
  },
];

const ActivityTime = ({ setActiveTab }) => {
  const dispatch = useDispatch();
  const { confirm } = Modal;
  const { id } = useParams();
  const [futureItems, setFutureItems] = useState([]);
  const [pastItems, setPastItems] = useState([]);
  const [activity, setActivity] = useState();
  const [isOpen, setIsOpen] = useState(true);
  const [isHistoryOpen, setIsHistoryOpen] = useState(true);

  const leadNotes = useSelector((state) => state.LeadDetailsReducer.leadNotes);
  const leadRemarks = useSelector(
    (state) => state.LeadDetailsReducer.leadRemarks
  );
  const leadDetail = useSelector(
    (state) => state.LeadDetailsReducer.leadDetails
  );
  const loading = useSelector((state) => state.LeadDetailsReducer.loading);

  const getActiveTab = (id, type) => {
    if (type === "deletenote") {
      showConfirm(id, leadDetail?.id, "note");
    } else if (type === "deleteremarks") {
      showConfirm(id, leadDetail?.id, "task");
    } else {
      if (type === "editnote") {
        dispatch(getLeadNoteDetails(id));
      } else if (type === "editremarks") {
        dispatch(getLeadRemarksDetails(id));
      }
    }
  };

  function showConfirm(id, leadId, type) {
    confirm({
      title: "Do you want to delete this " + type + "?",
      content: "",
      onOk() {
        return new Promise((resolve, reject) => {
          setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
          if (type === "note") {
            dispatch(deleteLeadNote(id, leadId));
          } else {
            dispatch(deleteLeadRemarks(id, leadId));
          }
        }).catch(() => console.log("Oops errors!"));
      },
      onCancel() {},
    });
  }

  useEffect(() => {
    if (id) {
      dispatch(getAllLeadNotes(id));
      dispatch(getAllLeadRemarks(id));
    }
  }, [dispatch, id]);

  const activityMeta = {
    call: ["las la-phone", "green"],
    email: ["las la-envelope", "green"],
    meeting: ["las la-handshake", "red"],
    followup: ["las la-file-alt", "gray"],
    chat: ["las la-comment-dots", "gray"],
    whatsapp: ["lab la-whatsapp", "red"],
  };

  const handleEdit = (id, isLead) => {
    getActiveTab(id, isLead ? "editnote" : "editremarks");
    setActiveTab(isLead ? "2" : "3");
    window.scrollTo({ top: 100, behavior: "smooth" });
  };

  const handleDelete = (id, isLead) => {
    getActiveTab(id, isLead ? "deletenote" : "deleteremarks");
  };

  const formatActivityItem = (item, isLead) => {
    const title = isLead ? "Note" : item.title;
    const description = isLead ? item.note : item.remarks;
    const rawTime = isLead ? item.lastUpdated : item.interactionDate;
    const formattedTime = moment(rawTime).utc().format("D MMMM YYYY, h:mm a");

    const [iconClass, color] = activityMeta[title] || [
      "las la-file-alt",
      "gray",
    ];
    let statusColor;
    switch (item?.status?.toLowerCase().trim()) {
      case "open":
        statusColor = "#1890ff";
        break;
      case "re-scheduled":
        statusColor = "#fa8c16";
        break;
      case "cancelled":
        statusColor = "#ff5252";
        break;
      case "completed":
        statusColor = "#52c41a";
        break;
      default:
        statusColor = "#bfbfbf";
        break;
    }

    return {
      color,
      dot: (
        <div
          style={{ border: "1px solid #e3e6f0" }}
          className={`text-color-6E6E6E d-flex align-items-center activity-icon rounded-circle`}
        >
          <i className={`${iconClass} heading18px`} />
        </div>
      ),
      children: (
        <div className="mt20 mb20">
          <div className="heading13px activities-card">
            <Row className="px-20 py-10">
              <Col
                span={24}
                md={18}
                className="text-align-left font-weight-normal"
                style={{ textTransform: "capitalize" }}
              >
                <span className="fw-bold heading18px">{title}</span>
                <div className="d-flex flex-column flex-md-row  align-items-center heading12px text-color-6E6E6E gap-10 heading12px mt10 mb10">
                  {item?.status && (
                    <>
                      <span
                        style={{
                          color: statusColor,
                          border: `1px solid ${statusColor}`,
                          padding: "0 10px",
                          borderRadius: 2,
                        }}
                      >
                        {item?.status}
                      </span>
                      <span
                        style={{
                          display: "inline-block",
                          width: 5,
                          height: 5,
                          borderRadius: "50%",
                          backgroundColor: "#6e6e6e",
                          marginRight: 8,
                        }}
                      />
                    </>
                  )}
                  <span className="fw-bold">{formattedTime}</span>
                  <span
                    style={{
                      display: "inline-block",
                      width: 5,
                      height: 5,
                      borderRadius: "50%",
                      backgroundColor: "#6e6e6e",
                      marginRight: 8,
                    }}
                  />
                  <span>{description}</span>
                </div>
              </Col>
              <Col span={24} md={6} className="text-align-right">
                <button
                  className="btn fs-20"
                  onClick={() => handleEdit(item.id, isLead)}
                >
                  <i className="las la-edit" />
                </button>
                <button
                  className="btn fs-20 text-error"
                  onClick={() => handleDelete(item.id, isLead)}
                >
                  <i className="las la-trash" />
                </button>
              </Col>
            </Row>
          </div>
        </div>
      ),
      istoday: moment(formattedTime).isAfter(moment()),
    };
  };

  useEffect(() => {
    const combined =
      activity === "notes"
        ? [...leadNotes.map((item) => ({ ...item, isLead: true }))]
        : activity
          ? [...leadRemarks.map((item) => ({ ...item, isLead: false }))]
          : [
              ...leadNotes.map((item) => ({ ...item, isLead: true })),
              ...leadRemarks.map((item) => ({ ...item, isLead: false })),
            ];
    const todayList = [];
    const pastList = [];

    combined.forEach((item) => {
      const formatted = formatActivityItem(item, item.isLead);
      if (formatted.istoday) {
        todayList.push(formatted);
      } else {
        pastList.push(formatted);
      }
    });

    setFutureItems(todayList);
    setPastItems(pastList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadNotes, leadRemarks, activity]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div id="lead-activity" className="mt40 activity-time">
      <div className="d-flex align-items-center justify-content-end">
        <Select
          className="leadBtn roboto-medium"
          placeholder="Activities"
          defaultValue={null}
          options={options}
          onChange={(value) => {
            setActivity(value);
            dispatch(getAllLeadRemarks(id, { activity: value }));
          }}
        />
      </div>

      {!!futureItems.length ? (
        <Collapse
          defaultActiveKey={["1"]}
          items={[
            {
              key: "1",
              label: (
                <div
                  className="heading d-flex justify-content-between"
                  style={{ width: "100%" }}
                >
                  <div className="heading18px fw-bold">Upcoming Activities</div>
                </div>
              ),
              extra: isOpen ? (
                <img
                  src={downIcon}
                  alt=""
                  style={{ transform: "rotate(180deg)", width: 20, height: 20 }}
                />
              ) : (
                <img src={downIcon} alt="" style={{ width: 20, height: 20 }} />
              ),
              showArrow: false,
              children: <Timeline items={futureItems} />,
            },
          ]}
          onChange={() => setIsOpen(!isOpen)}
          className="mt20"
          style={{ borderRadius: "4px" }}
        />
      ) : (
        <>
          <div className="heading18px fw-bold">Activities</div>

          <div className="d-flex mt30 flex-column text-center gap-10 align-items-center">
            <div className="fw-semibold">No Activities Scheduled</div>
            <div className="text-gray" style={{ maxWidth: 400 }}>
              Your scheduled activities, pinned reminders, email drafts, and
              queued emails will show up here.
            </div>
            <Button
              type="link"
              className="text-theme fw-bold"
              onClick={() => {
                setActiveTab("3");
              }}
            >
              <i className="fa fa-plus" aria-hidden="true"></i>Schedule an
              activity
            </Button>
          </div>
        </>
      )}

      {!!pastItems.length && (
        <Collapse
          defaultActiveKey={["1"]}
          items={[
            {
              key: "1",
              label: (
                <div
                  className="heading d-flex justify-content-between"
                  style={{ width: "100%" }}
                >
                  <div className="heading18px fw-bold">History</div>
                </div>
              ),
              extra: isHistoryOpen ? (
                <img
                  src={downIcon}
                  alt=""
                  style={{ transform: "rotate(180deg)", width: 20, height: 20 }}
                />
              ) : (
                <img src={downIcon} alt="" style={{ width: 20, height: 20 }} />
              ),
              showArrow: false,
              children: <Timeline items={pastItems} />,
            },
          ]}
          onChange={() => setIsHistoryOpen(!isHistoryOpen)}
          className="mt20"
          style={{ borderRadius: "4px" }}
        />
      )}
    </div>
  );
};

export default ActivityTime;
